/**
 * @generated SignedSource<<d778ca145e5ad07c97cfb591991797e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentsReopenThreadMutation$variables = {
  id: string;
};
export type CommentsReopenThreadMutation$data = {
  readonly Comment_ReopenThread: {
    readonly thread: {
      readonly id: string;
      readonly resolvedBy: {
        readonly id: string;
      } | null;
    };
  } | null;
};
export type CommentsReopenThreadMutation = {
  response: CommentsReopenThreadMutation$data;
  variables: CommentsReopenThreadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "threadId",
        "variableName": "id"
      }
    ],
    "concreteType": "ReopenThread",
    "kind": "LinkedField",
    "name": "Comment_ReopenThread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CommentThread",
        "kind": "LinkedField",
        "name": "thread",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "resolvedBy",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsReopenThreadMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsReopenThreadMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "725a078bf4b90a502ec699e6f201a845",
    "id": null,
    "metadata": {},
    "name": "CommentsReopenThreadMutation",
    "operationKind": "mutation",
    "text": "mutation CommentsReopenThreadMutation(\n  $id: ID!\n) {\n  Comment_ReopenThread(threadId: $id) {\n    thread {\n      id\n      resolvedBy {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "13cb382ff24a73a85f99b44acae64e6d";

export default node;
